module.exports = {
    /**
     * 监听导航条的点击事件<br />
     * 使用场景：需要在点击导航条时触发一定条件时调用<br />
     * 对应native接口：navigation.click
     * @method hysdk.onNavClick
     * @category Navigation Event
     * @example ./onNavClick.js[1-53]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    navClick: {
        hy: {
            key: 'navigation.click'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/events/navigation.js
// module id = 24
// module chunks = 0 2 4